import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/passage-ceinture-documents`;

const getAuthConfig = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getAllPassageCeintureDocuments = async () => {
  const response = await axios.get(`${apiUrl}/all`, getAuthConfig());
  return response.data;
};

export const getPublishedPassageCeintureDocuments = async () => {
  const response = await axios.get(`${apiUrl}/published`, getAuthConfig());
  return response.data;
};

export const getPassageCeintureDocumentsByBelt = async (ceinture) => {
  const response = await axios.get(
    `${apiUrl}/by-belt/${encodeURIComponent(ceinture)}`,
    getAuthConfig()
  );
  return response.data;
};

export const addPassageCeintureDocument = async (payload) => {
  const response = await axios.post(`${apiUrl}/add`, payload, getAuthConfig());
  return response.data;
};

export const updatePassageCeintureDocument = async (id, payload) => {
  const response = await axios.put(
    `${apiUrl}/update/${id}`,
    payload,
    getAuthConfig()
  );
  return response.data;
};

export const deletePassageCeintureDocument = async (id) => {
  const response = await axios.delete(
    `${apiUrl}/delete/${id}`,
    getAuthConfig()
  );
  return response.data;
};

export const uploadPassageCeintureImage = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const token = localStorage.getItem("token");
  const response = await axios.post(`${apiUrl}/${id}/image`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const deletePassageCeintureImage = async (id) => {
  const response = await axios.delete(`${apiUrl}/${id}/image`, getAuthConfig());
  return response.data;
};

export const uploadPassageCeinturePdf = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const token = localStorage.getItem("token");
  const response = await axios.post(`${apiUrl}/${id}/pdf`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const deletePassageCeinturePdf = async (id) => {
  const response = await axios.delete(`${apiUrl}/${id}/pdf`, getAuthConfig());
  return response.data;
};